import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import nissan from "./../../../../assets/info/x-trail-hero.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const NissanXTrail = () => {
  useSmallNav("Nissan X-Trail");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan X-Trail"} bolder />
        <InfoHero image={nissan} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={"Want more ground clearance from your Nissan X-Trail?"}
            />
            <InfoHeader text={"Then we can help you!"} />
            <p>
              Pedders Suspension offer everything you need to raise your
              X-Trail. Our lift kit features four Pedders TrakRyder springs and
              four of our TrakRyder Dampers as well as a set of camber
              adjustment bolts (T30 only). Not sure if this is the right kit?
              Listed below are some of the common questions about our kit.
            </p>
            <InfoHeader text={"How much does this raise my X-Trail?"} smaller />
            <p>
              Here at Pedders, we try to avoid quoting a raise, rather we quote
              an installed height. Why do we do this? Simply, because, springs
              settle over time dependant on use mileage etc. Our kits may give a
              raise of, for example, 1 inch, but if your car is already an inch
              lower than when it was new, this would equate to 2 inches when the
              new springs were fitted.
            </p>
            <p>
              So, to answer the question, the installed height of our kit is
              710mm at the front, 715mm at the rear (16 inch wheels) for T30
              models (2001-2007), and 695mm at the front, 705mm at the rear (17
              inch wheels) for T31 models (2007-onwards). This is measured from
              the bottom of the wheel RIM to the bottom of the wheel-arch as
              shown in the diagram on the right.
            </p>
            <InfoHeader
              text={"I've heard that you cant raise an X-Trail?"}
              size="smaller"
            />
            <p>
              There are limits as to how high you can go. On the X-Trail, the
              limiting factor is CV joint angle. If you raise the vehicle too
              far, you will cause the CV joints to go beyond their range of
              travel. This causes permanent damage to the CV Joints and possible
              damage to other components. Pedders have taken this into account
              when designing and specifying the final installed height. You can
              be sure that this will not be a problem.
            </p>
            <InfoHeader text={"What are these camber adjusters?"} smaller />
            <p>
              When raising, or for that matter lowering a vehicle, the camber
              angle of the wheel will change. I.e., the amount the top of the
              wheel leans in or out. Leaning in is negative camber, leaning out
              is positive. When raising the X-Trail T30, it is likely that the
              camber will become more positive and fall outside of Nissan's
              specifications. As camber is not adjustable as standard on the
              X-Trail T30, we can supply a set of adjustable bolts that allow
              adjustments to be made once fitted to ensure the camber angle
              meets the specification. It is for this reason we always recommend
              that you have the suspension geometry checked after fitting our
              kit or making any other changes to the suspension.
            </p>
            <InfoHeader text={"Do your kits fit Diesel Models?"} smaller />
            <p>
              Pedders Suspension can now offer lifting springs for both the
              Petrol and Diesel Models of T30 and T31.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "X-Trail")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title={"Nissan X-Trail Video 1"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan X-Trail Video 2"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Nissan" model="X-Trail" />
      </Container>
    </section>
  );
};

export default NissanXTrail;
